<script>
import iCompetition from './_competition.js';
import roundMatch from './CompetitionRoundMatch.vue';
import roundPool from "./CompetitionRoundPool";
import matchEntity from './MatchEntity.vue';

export default {
  name: 'match',

  mixins: [iCompetition],

  data() {
    return {
      home_url: home_url,
      referrer: referrer,
      competition_id: competition_id,
      match_id: match_id,
      competition: {},
      results: null,
      rounds: null,
      match: {},
      isLoading: false,
    }
  },

  components: {
    roundMatch,
    matchEntity
  },

  template: `
    <div class="dash-public-plugin-container dash-public-plugin-match" v-bind:class="{'is-loading': isLoading}">
        <div class="dash-public-plugin-container-header no-border">
          <div>
            <div v-if="referrer">
              <button class="go-back" onclick="history.back(-1)">Go back</button>
            </div>
            <div v-else>
              <a class="go-back" :href="home_url + '/competitions/' + competition_id">Go back</a>
            </div>
          </div>
          
          <div class="header-row">
            <div class="header-title">{{ competition.display_name }}</div>
            <div class="header-actions"></div>
          </div>
          
          <div class="header-row">
            <div class="header-meta">
              <div>{{ match.round.title }}</div>
              <div v-if="!match.date">{{ match.round.date | formatDate }}</div>
            </div>
          </div>
        </div>

        <div class="dash-public-plugin-container-content">
          <div class="match-info">
            <div class="match-position">
              <div><span>Match {{ match.position }}</span></div>
            </div>
            <div class="match-entities">
              <match-entity
                :entity="match.entityA"
                :rounds="rounds"
                :results="results"
                :applications="competition.applications"
                :match="match"
                :isEntityA="true"
                :isHome="match.entityA_home"
                :delegated_progression="competition.delegated_progression"
              >
              </match-entity>
              <div class="verse">
                <i class="fa-solid fa-v"></i>
              </div>
              <match-entity
                :entity="match.entityB"
                :rounds="rounds"
                :results="results"
                :applications="competition.applications"
                :match="match"
                :isEntityA="true"
                :isHome="match.entityB_home"
                :delegated_progression="competition.delegated_progression"
              >
              </match-entity>
            </div>

            <div class="match-meta">
              <div v-if="match.start_time" class="match-time">
                <div>{{match.start_time | formatTime}}</div>
              </div>
              <div v-if="match.date && competition_type == 'round robin'" class="match-date">{{ match.date | formatDate }}</div>
              <div v-else class="match-date">{{match.round.date | formatDate}}</div>
              <div v-if="match.facility" class="match-location">
                <span v-if="match.facility.venue_title">{{match.facility.venue_title}}</span>
               <span v-if="match.facility.title">{{match.facility.title}}</span>
              </div>
            </div>
          </div>
        </div>
    </div>
  `,

  mounted() {
    this.getData();
  },

  methods: {
    getData: function () {
      const $this = this;

      $this.getCompetition(competition_id, function (competition, results) {
        $this.competition = competition;
        $this.results = results;
      })
    },
  },

  watch: {
    competition: function (value) {
      const $this = this;

      if (value && 'latest_version' in value) {
        let comp_version = JSON.parse(value.latest_version.competition_serialised);

        if ('rounds' in comp_version) {
          this.rounds = comp_version.rounds;
        }

        this.match = $this.getMatchByKey(match_id, this.rounds);

        $this.isLoading = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
